@if (legacyStripAllowed() && renderElement) {
  <!-- Never scrolls sideways or cuts a word: crumbs wrap to a second line,
       a single crumb wider than the page ends in «…». pb-4 keeps 16px to the
       page title on mobile, where the outlet has no top padding. -->
  <div
    class="bn-legacy-breadcrumbs min-w-0 max-w-full pb-4 pl-0 pr-4 pt-0 md:pb-0 md:pr-0 md:pt-8"
    [ngClass]="{
      'md:pl-16': align() === 'indent',
      'md:grid md:grid-cols-12':
        align() === 'column' ||
        align() === 'contact' ||
        align() === 'wide' ||
        align() === 'detail',
      'md:gap-4': align() === 'wide'
    }">
    <div
      class="min-w-0"
      [ngClass]="{
        'md:col-span-9 md:col-start-4': align() === 'column',
        'md:col-span-8 md:col-start-3': align() === 'contact',
        'md:col-span-12 lg:col-span-9 lg:col-start-3': align() === 'wide',
        'md:col-span-12 lg:col-span-8 lg:col-start-3': align() === 'detail',
        'mx-auto max-w-3xl': align() === 'templates'
      }">
      @if (navigating()) {
        <div
          class="h-4 w-64 max-w-full shrink-0 rounded bg-slate-200 bn-shimmer"
          aria-hidden="true"></div>
      } @else {
        @if (crumbs$ | async; as crumbs) {
          <div
            class="bn-legacy-breadcrumbs-row flex min-w-0 max-w-full flex-wrap items-center gap-x-2 gap-y-1">
            @for (
              crumb of crumbs;
              let i = $index;
              track i + '-' + (crumb.link ?? '') + '-' + (crumb.text ?? '')
            ) {
              <div class="breadcrumbs min-w-0 max-w-full gap-2">
                <a
                  class="crumb min-w-0 truncate text-sm"
                  [routerLink]="crumb.link"
                  [attr.title]="crumb.text"
                  >{{ crumb.text }}</a
                >
                @if (showSeperator(i, crumbs)) {
                  <mat-icon
                    class="material-symbols-rounded crumb-icon shrink-0">
                    chevron_right
                  </mat-icon>
                }
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
}
